import { createFileRoute } from '@tanstack/react-router'
import { WargaBeranda } from '../../../../components/warga/WargaBeranda'

export const Route = createFileRoute('/desa/$slug/warga/')({
  component: WargaBeranda,
})
